import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from 'components/buttons/Button';
import DownloadIcon from 'mdi-react/DownloadIcon';
import { Route, Switch } from 'react-router-dom';
import { Card } from 'reactstrap';
import qs from 'qs';
import {
  dashboardTopLeadsTab,
  dashboardPotentialReachTab,
  dashboardTopLeadsTabPath,
  dashboardPotentialReachTabPath,
} from 'constants/routing';
import Tabs from 'components/Tabs';
import NavLinkWrapper from 'components/Tabs/NavLinkWrapper';
import { getTimezoneAndUTCOffset, prepareFilterParams } from 'utils/report';
import {
  apiDashboardTopLeadsExportCSV,
} from 'constants/apiRouting';
import BasicNotification from 'components/Notification';
import { notification, defaultNoticeConfig } from 'utils/notifications';
import { CSV_ON_WAY_MESSAGE, UNEXPECTED_ERROR } from 'constants/csv_download';
import CampaignSummaryTab from './CampaignSummaryTab';
import TopLeadsTab from './TopLeadsTab';


const DashboardListStats = (props) => {
  const {
    className,
    topLeads,
    location,
    dashboard,
  } = props;

  const ref = useRef();
  const campaignSummaryPath = dashboardPotentialReachTabPath(props.match.path);
  const dashboardPath = dashboardPotentialReachTabPath(props.match.path, true);
  const topLeadsPath = dashboardTopLeadsTabPath(props.match.url);

  const downloadTopLeadsCSV = async () => {
    const filterParams = {
      ...prepareFilterParams(props.dashboardParams),
      ...getTimezoneAndUTCOffset(),
    };

    try {
      const res = await axios.get(apiDashboardTopLeadsExportCSV(), {
        params: filterParams,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      });
      if (res.status === 200) {
        notification.notice({
          content: <BasicNotification
            color="success"
            message={CSV_ON_WAY_MESSAGE}
          />,
          ...defaultNoticeConfig,
        });
      } else {
        notification.notice({
          content: <BasicNotification
            color="danger"
            message={UNEXPECTED_ERROR}
          />,
          ...defaultNoticeConfig,
        });
      }
    } catch (error) {
      notification.notice({
        content: <BasicNotification
          color="danger"
          message={UNEXPECTED_ERROR}
        />,
        ...defaultNoticeConfig,
      });
    }
  };

  useEffect(() => {
    if ([topLeadsPath, campaignSummaryPath].includes(location.pathname)) {
      ref.current.scrollIntoView({
        inline: 'start',
      });
    }
  }, [location.pathname]);

  const isCampaignSummaryActive = () => dashboardPath === location.pathname
    || campaignSummaryPath === location.pathname;

  return (
    <Card className={className}>
      <div ref={ref} />
      <Tabs style={{ alignItems: 'center' }}>
        <NavLinkWrapper
          exact
          to={dashboardPotentialReachTab(props.match.url)}
          isActive={isCampaignSummaryActive}
          className="nav-link"
        >
          Campaign Summary
        </NavLinkWrapper>
        <NavLinkWrapper
          exact
          to={dashboardTopLeadsTab(props.match.url)}
          className="nav-link"
        >
          Top Leads
        </NavLinkWrapper>
        <div style={{ flex: 1 }} />
        <Route
          path={topLeadsPath}
          render={() => (
            <Button
              style={{ margin: 'auto 5px' }}
              color="primary"
              variant="contained"
              type="text/csv"
              startIcon={<DownloadIcon />}
              size="small"
              disabled={topLeads.loading || topLeads.results.length <= 0 || dashboard.isMocked}
              onClick={downloadTopLeadsCSV}
            >
              Download leads
            </Button>
          )}
        />
      </Tabs>
      <Switch>
        <Route
          path={[campaignSummaryPath, dashboardPath]}
          exact
          render={() => (
            <CampaignSummaryTab />
          )}
        />
        <Route
          path={dashboardTopLeadsTabPath(props.match.path)}
          render={() => (
            <TopLeadsTab />
          )}
        />
      </Switch>
    </Card>
  );
};

DashboardListStats.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string.isRequired,
  topLeads: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dashboard: PropTypes.shape({
    isMocked: PropTypes.bool,
  }).isRequired,
  dashboardParams: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default compose(
  connect(
    state => ({
      topLeads: state.dashboard.topLeads,
      dashboardParams: state.dashboard.dashboardParams,
      dashboard: state.dashboard,
    }),
    null,
  ),
  withNamespaces('common'),
)(DashboardListStats);
